export default "assets/images/stries-vertical-6bf8e004.svg";